import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M22.101 9.053a2.75 2.75 0 0 0-1.987-.717 2.75 2.75 0 0 0-1.912.899l-2.948 3.24a2.88 2.88 0 0 0-2.466-1.393h-8.12a3.67 3.67 0 0 0-3.667 3.667v4.584A3.67 3.67 0 0 0 4.668 23H9.22a9.18 9.18 0 0 0 6.844-3.07l6.238-7.002a2.77 2.77 0 0 0-.2-3.875m-1.167 2.657-6.239 7.002a7.35 7.35 0 0 1-5.475 2.455H4.668a1.835 1.835 0 0 1-1.833-1.833V14.75c0-1.011.822-1.833 1.833-1.833h8.12c.578 0 1.047.47 1.047 1.047 0 .517-.386.964-.899 1.036l-4.731.676a.917.917 0 0 0 .26 1.816l4.73-.676A2.9 2.9 0 0 0 15.5 14.93l4.058-4.46a.92.92 0 0 1 .641-.3.9.9 0 0 1 .668.24c.373.34.403.925.067 1.303zM4.938 5.12a.764.764 0 0 1 .494-1.346h2.292l.812-2.276a.763.763 0 0 1 1.432 0l.811 2.276h2.293a.764.764 0 0 1 .492 1.349l-1.807 1.472.747 2.277a.763.763 0 0 1-1.142.88l-2.104-1.37L7.19 9.765a.76.76 0 0 1-.883-.023.76.76 0 0 1-.27-.84l.719-2.304z"
    }, null, -1)
  ]))]))
}
export default { render: render }